// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/coins/v2/types.proto (package creativefabrica.coins.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/coins/v2/types.proto.
 */
export const file_creativefabrica_coins_v2_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * @generated from message creativefabrica.coins.v2.ActionPricing
 */
export type ActionPricing = Message<"creativefabrica.coins.v2.ActionPricing"> & {
  /**
   * @generated from field: creativefabrica.coins.v2.PricingAction action = 1;
   */
  action: PricingAction;

  /**
   * @generated from field: int64 amount = 2;
   */
  amount: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.ActionPricing
 */
export type ActionPricingJson = {
  /**
   * @generated from field: creativefabrica.coins.v2.PricingAction action = 1;
   */
  action?: PricingActionJson;

  /**
   * @generated from field: int64 amount = 2;
   */
  amount?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.ActionPricing.
 * Use `create(ActionPricingSchema)` to create a new message.
 */
export const ActionPricingSchema: GenMessage<ActionPricing, {jsonType: ActionPricingJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 0);

/**
 * @generated from message creativefabrica.coins.v2.AutoTopUpSettings
 */
export type AutoTopUpSettings = Message<"creativefabrica.coins.v2.AutoTopUpSettings"> & {
  /**
   * The effective setting. Users with no stored preference are opted in, so
   * this field is true unless the user has explicitly opted out.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * The one-time coin pack purchased when automatic top-up is triggered.
   * Users with no stored preference receive the 250K pack.
   *
   * @generated from field: creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack: AutoTopUpPack;
};

/**
 * @generated from message creativefabrica.coins.v2.AutoTopUpSettings
 */
export type AutoTopUpSettingsJson = {
  /**
   * The effective setting. Users with no stored preference are opted in, so
   * this field is true unless the user has explicitly opted out.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled?: boolean;

  /**
   * The one-time coin pack purchased when automatic top-up is triggered.
   * Users with no stored preference receive the 250K pack.
   *
   * @generated from field: creativefabrica.coins.v2.AutoTopUpPack pack = 2;
   */
  pack?: AutoTopUpPackJson;
};

/**
 * Describes the message creativefabrica.coins.v2.AutoTopUpSettings.
 * Use `create(AutoTopUpSettingsSchema)` to create a new message.
 */
export const AutoTopUpSettingsSchema: GenMessage<AutoTopUpSettings, {jsonType: AutoTopUpSettingsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 1);

/**
 * Team-pool coin settings. Distinct from personal AutoTopUpSettings.
 * Field names match team_settings columns.
 *
 * @generated from message creativefabrica.coins.v2.TeamSettings
 */
export type TeamSettings = Message<"creativefabrica.coins.v2.TeamSettings"> & {
  /**
   * When true, members may exceed their personal coin allowance; excess draws
   * from the shared team pool. Missing rows default to true.
   *
   * @generated from field: bool overflow_enabled = 1;
   */
  overflowEnabled: boolean;

  /**
   * When true, automatically buy a coin pack when the team pool dips below
   * auto_top_up_threshold.
   *
   * @generated from field: bool auto_top_up_enabled = 2;
   */
  autoTopUpEnabled: boolean;

  /**
   * Team-pool balance (coins) that triggers a pack purchase when
   * auto_top_up_enabled is true. Front-end slider range is 25000–500000. Zero
   * means unset (no stored preference yet).
   *
   * @generated from field: int64 auto_top_up_threshold = 3;
   */
  autoTopUpThreshold: bigint;

  /**
   * Pack purchased on trigger. UNSPECIFIED means unset (no stored preference).
   *
   * @generated from field: creativefabrica.coins.v2.TeamAutoTopUpPack auto_top_up_pack = 4;
   */
  autoTopUpPack: TeamAutoTopUpPack;
};

/**
 * Team-pool coin settings. Distinct from personal AutoTopUpSettings.
 * Field names match team_settings columns.
 *
 * @generated from message creativefabrica.coins.v2.TeamSettings
 */
export type TeamSettingsJson = {
  /**
   * When true, members may exceed their personal coin allowance; excess draws
   * from the shared team pool. Missing rows default to true.
   *
   * @generated from field: bool overflow_enabled = 1;
   */
  overflowEnabled?: boolean;

  /**
   * When true, automatically buy a coin pack when the team pool dips below
   * auto_top_up_threshold.
   *
   * @generated from field: bool auto_top_up_enabled = 2;
   */
  autoTopUpEnabled?: boolean;

  /**
   * Team-pool balance (coins) that triggers a pack purchase when
   * auto_top_up_enabled is true. Front-end slider range is 25000–500000. Zero
   * means unset (no stored preference yet).
   *
   * @generated from field: int64 auto_top_up_threshold = 3;
   */
  autoTopUpThreshold?: string;

  /**
   * Pack purchased on trigger. UNSPECIFIED means unset (no stored preference).
   *
   * @generated from field: creativefabrica.coins.v2.TeamAutoTopUpPack auto_top_up_pack = 4;
   */
  autoTopUpPack?: TeamAutoTopUpPackJson;
};

/**
 * Describes the message creativefabrica.coins.v2.TeamSettings.
 * Use `create(TeamSettingsSchema)` to create a new message.
 */
export const TeamSettingsSchema: GenMessage<TeamSettings, {jsonType: TeamSettingsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 2);

/**
 * @generated from message creativefabrica.coins.v2.TeamMemberStats
 */
export type TeamMemberStats = Message<"creativefabrica.coins.v2.TeamMemberStats"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string user_name = 2;
   */
  userName: string;

  /**
   * @generated from field: string user_role = 3;
   */
  userRole: string;

  /**
   * @generated from field: int64 period_coins_spent = 4;
   */
  periodCoinsSpent: bigint;

  /**
   * @generated from field: int64 previous_period_coins_spent = 5;
   */
  previousPeriodCoinsSpent: bigint;

  /**
   * @generated from field: int64 period_overflow_coins_used = 6;
   */
  periodOverflowCoinsUsed: bigint;

  /**
   * @generated from field: int64 previous_period_overflow_coins_used = 7;
   */
  previousPeriodOverflowCoinsUsed: bigint;

  /**
   * @generated from field: string user_status = 8;
   */
  userStatus: string;

  /**
   * @generated from field: string user_email = 9;
   */
  userEmail: string;

  /**
   * @generated from field: string user_avatar_url = 10;
   */
  userAvatarUrl: string;
};

/**
 * @generated from message creativefabrica.coins.v2.TeamMemberStats
 */
export type TeamMemberStatsJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string user_name = 2;
   */
  userName?: string;

  /**
   * @generated from field: string user_role = 3;
   */
  userRole?: string;

  /**
   * @generated from field: int64 period_coins_spent = 4;
   */
  periodCoinsSpent?: string;

  /**
   * @generated from field: int64 previous_period_coins_spent = 5;
   */
  previousPeriodCoinsSpent?: string;

  /**
   * @generated from field: int64 period_overflow_coins_used = 6;
   */
  periodOverflowCoinsUsed?: string;

  /**
   * @generated from field: int64 previous_period_overflow_coins_used = 7;
   */
  previousPeriodOverflowCoinsUsed?: string;

  /**
   * @generated from field: string user_status = 8;
   */
  userStatus?: string;

  /**
   * @generated from field: string user_email = 9;
   */
  userEmail?: string;

  /**
   * @generated from field: string user_avatar_url = 10;
   */
  userAvatarUrl?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.TeamMemberStats.
 * Use `create(TeamMemberStatsSchema)` to create a new message.
 */
export const TeamMemberStatsSchema: GenMessage<TeamMemberStats, {jsonType: TeamMemberStatsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 3);

/**
 * Per-key spend from apikey:<id> tracking buckets. period_coins_spent is
 * overflow_used (seat used stays 0 on these rows). Name and prefix come from
 * IAM enrichment and may be empty if the key is missing or deleted.
 *
 * @generated from message creativefabrica.coins.v2.TeamApiKeyStats
 */
export type TeamApiKeyStats = Message<"creativefabrica.coins.v2.TeamApiKeyStats"> & {
  /**
   * @generated from field: string api_key_id = 1;
   */
  apiKeyId: string;

  /**
   * @generated from field: string api_key_name = 2;
   */
  apiKeyName: string;

  /**
   * @generated from field: string api_key_prefix = 3;
   */
  apiKeyPrefix: string;

  /**
   * @generated from field: int64 period_coins_spent = 4;
   */
  periodCoinsSpent: bigint;

  /**
   * @generated from field: int64 previous_period_coins_spent = 5;
   */
  previousPeriodCoinsSpent: bigint;
};

/**
 * Per-key spend from apikey:<id> tracking buckets. period_coins_spent is
 * overflow_used (seat used stays 0 on these rows). Name and prefix come from
 * IAM enrichment and may be empty if the key is missing or deleted.
 *
 * @generated from message creativefabrica.coins.v2.TeamApiKeyStats
 */
export type TeamApiKeyStatsJson = {
  /**
   * @generated from field: string api_key_id = 1;
   */
  apiKeyId?: string;

  /**
   * @generated from field: string api_key_name = 2;
   */
  apiKeyName?: string;

  /**
   * @generated from field: string api_key_prefix = 3;
   */
  apiKeyPrefix?: string;

  /**
   * @generated from field: int64 period_coins_spent = 4;
   */
  periodCoinsSpent?: string;

  /**
   * @generated from field: int64 previous_period_coins_spent = 5;
   */
  previousPeriodCoinsSpent?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.TeamApiKeyStats.
 * Use `create(TeamApiKeyStatsSchema)` to create a new message.
 */
export const TeamApiKeyStatsSchema: GenMessage<TeamApiKeyStats, {jsonType: TeamApiKeyStatsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 4);

/**
 * @generated from message creativefabrica.coins.v2.UserTransactionStats
 */
export type UserTransactionStats = Message<"creativefabrica.coins.v2.UserTransactionStats"> & {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName: string;

  /**
   * @generated from field: string category = 2;
   */
  category: string;

  /**
   * @generated from field: int32 runs = 3;
   */
  runs: number;

  /**
   * @generated from field: int64 coins_spent = 4;
   */
  coinsSpent: bigint;
};

/**
 * @generated from message creativefabrica.coins.v2.UserTransactionStats
 */
export type UserTransactionStatsJson = {
  /**
   * @generated from field: string tool_name = 1;
   */
  toolName?: string;

  /**
   * @generated from field: string category = 2;
   */
  category?: string;

  /**
   * @generated from field: int32 runs = 3;
   */
  runs?: number;

  /**
   * @generated from field: int64 coins_spent = 4;
   */
  coinsSpent?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.UserTransactionStats.
 * Use `create(UserTransactionStatsSchema)` to create a new message.
 */
export const UserTransactionStatsSchema: GenMessage<UserTransactionStats, {jsonType: UserTransactionStatsJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 5);

/**
 * @generated from message creativefabrica.coins.v2.Transaction
 */
export type Transaction = Message<"creativefabrica.coins.v2.Transaction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionType type = 2;
   */
  type: TransactionType;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionStatus status = 3;
   */
  status: TransactionStatus;

  /**
   * @generated from field: string user_id = 4;
   */
  userId: string;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount: bigint;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionOrigin origin = 6;
   */
  origin: TransactionOrigin;

  /**
   * @generated from field: string object_id = 7;
   */
  objectId: string;

  /**
   * @generated from field: google.protobuf.Timestamp confirm_time = 8;
   */
  confirmTime?: Timestamp | undefined;

  /**
   * @generated from field: string reason = 9;
   */
  reason: string;

  /**
   * @generated from field: string display_label = 10;
   */
  displayLabel: string;
};

/**
 * @generated from message creativefabrica.coins.v2.Transaction
 */
export type TransactionJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionType type = 2;
   */
  type?: TransactionTypeJson;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionStatus status = 3;
   */
  status?: TransactionStatusJson;

  /**
   * @generated from field: string user_id = 4;
   */
  userId?: string;

  /**
   * @generated from field: int64 amount = 5;
   */
  amount?: string;

  /**
   * @generated from field: creativefabrica.coins.v2.TransactionOrigin origin = 6;
   */
  origin?: TransactionOriginJson;

  /**
   * @generated from field: string object_id = 7;
   */
  objectId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp confirm_time = 8;
   */
  confirmTime?: TimestampJson;

  /**
   * @generated from field: string reason = 9;
   */
  reason?: string;

  /**
   * @generated from field: string display_label = 10;
   */
  displayLabel?: string;
};

/**
 * Describes the message creativefabrica.coins.v2.Transaction.
 * Use `create(TransactionSchema)` to create a new message.
 */
export const TransactionSchema: GenMessage<Transaction, {jsonType: TransactionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_coins_v2_types, 6);

/**
 * @generated from enum creativefabrica.coins.v2.PricingAction
 */
export enum PricingAction {
  /**
   * @generated from enum value: PRICING_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Flow.
   *
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_SAI = 1;
   */
  FLOW_GENERATE_IMAGE_SAI = 1,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA = 2;
   */
  FLOW_GENERATE_IMAGE_NANO_BANANA = 2,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA_PRO = 3;
   */
  FLOW_GENERATE_IMAGE_NANO_BANANA_PRO = 3,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA_2 = 4;
   */
  FLOW_GENERATE_IMAGE_NANO_BANANA_2 = 4,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_IMAGE_GEN_4 = 5;
   */
  FLOW_GENERATE_IMAGE_IMAGE_GEN_4 = 5,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_GROK_2 = 6;
   */
  FLOW_GENERATE_IMAGE_GROK_2 = 6,

  /**
   * @generated from enum value: PRICING_ACTION_FLOW_GENERATE_IMAGE_GPT_IMAGE_2 = 7;
   */
  FLOW_GENERATE_IMAGE_GPT_IMAGE_2 = 7,

  /**
   * Lumo.
   *
   * @generated from enum value: PRICING_ACTION_LUMO_GENERATE_IMAGE_NANO_BANANA_2 = 8;
   */
  LUMO_GENERATE_IMAGE_NANO_BANANA_2 = 8,

  /**
   * Image editor.
   *
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_PRO_PREVIEW = 9;
   */
  IMAGE_EDITOR_GEMINI_3_PRO_PREVIEW = 9,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE_PREVIEW = 10;
   */
  IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE_PREVIEW = 10,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_GEMINI_2_5 = 56;
   */
  IMAGE_EDITOR_GEMINI_2_5 = 56,

  /**
   * Studio tools.
   *
   * @generated from enum value: PRICING_ACTION_LOGO_GENERATOR = 11;
   */
  LOGO_GENERATOR = 11,

  /**
   * @generated from enum value: PRICING_ACTION_DESIGN_REVIEW = 12;
   */
  DESIGN_REVIEW = 12,

  /**
   * @generated from enum value: PRICING_ACTION_QUOTE_GENERATOR = 13;
   */
  QUOTE_GENERATOR = 13,

  /**
   * @generated from enum value: PRICING_ACTION_COLLAGE = 14;
   */
  COLLAGE = 14,

  /**
   * @generated from enum value: PRICING_ACTION_DOODLE_PET = 15;
   */
  DOODLE_PET = 15,

  /**
   * @generated from enum value: PRICING_ACTION_REMOVE_PEOPLE_FROM_BACKGROUND = 16;
   */
  REMOVE_PEOPLE_FROM_BACKGROUND = 16,

  /**
   * @generated from enum value: PRICING_ACTION_COLORING_PAGE_MAKER = 17;
   */
  COLORING_PAGE_MAKER = 17,

  /**
   * @generated from enum value: PRICING_ACTION_WEDDING_INVITE = 18;
   */
  WEDDING_INVITE = 18,

  /**
   * @generated from enum value: PRICING_ACTION_TOON_FAMILY = 19;
   */
  TOON_FAMILY = 19,

  /**
   * @generated from enum value: PRICING_ACTION_CAMERA_ANGLE = 20;
   */
  CAMERA_ANGLE = 20,

  /**
   * @generated from enum value: PRICING_ACTION_MARKETPLACE_EDITOR = 21;
   */
  MARKETPLACE_EDITOR = 21,

  /**
   * @generated from enum value: PRICING_ACTION_SVG_GENERATOR = 22;
   */
  SVG_GENERATOR = 22,

  /**
   * @generated from enum value: PRICING_ACTION_WATERMARK_REMOVER = 23;
   */
  WATERMARK_REMOVER = 23,

  /**
   * @generated from enum value: PRICING_ACTION_ETSY_COACH = 24;
   */
  ETSY_COACH = 24,

  /**
   * registry key: "3d_model"
   *
   * @generated from enum value: PRICING_ACTION_THREE_D_MODEL = 25;
   */
  THREE_D_MODEL = 25,

  /**
   * @generated from enum value: PRICING_ACTION_MESH = 26;
   */
  MESH = 26,

  /**
   * @generated from enum value: PRICING_ACTION_FREEFORM_CAD = 27;
   */
  FREEFORM_CAD = 27,

  /**
   * @generated from enum value: PRICING_ACTION_SPLAT = 28;
   */
  SPLAT = 28,

  /**
   * @generated from enum value: PRICING_ACTION_FONT_GENERATOR = 29;
   */
  FONT_GENERATOR = 29,

  /**
   * Music generation.
   *
   * @generated from enum value: PRICING_ACTION_MUSIC_ELEVENLABS_10S = 30;
   */
  MUSIC_ELEVENLABS_10S = 30,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_ELEVENLABS_30S = 31;
   */
  MUSIC_ELEVENLABS_30S = 31,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_ELEVENLABS_60S = 32;
   */
  MUSIC_ELEVENLABS_60S = 32,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_ELEVENLABS_120S = 33;
   */
  MUSIC_ELEVENLABS_120S = 33,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_ELEVENLABS_180S = 34;
   */
  MUSIC_ELEVENLABS_180S = 34,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_LYRIA_3_FULL = 35;
   */
  MUSIC_LYRIA_3_FULL = 35,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_LYRIA_3_30S = 36;
   */
  MUSIC_LYRIA_3_30S = 36,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_LYRIA_2_30S = 37;
   */
  MUSIC_LYRIA_2_30S = 37,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_LYRICS_ELEVENLABS = 38;
   */
  MUSIC_LYRICS_ELEVENLABS = 38,

  /**
   * @generated from enum value: PRICING_ACTION_MUSIC_LYRICS_STRUCTURED = 39;
   */
  MUSIC_LYRICS_STRUCTURED = 39,

  /**
   * Sound generation.
   *
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_1S = 40;
   */
  SOUND_ELEVENLABS_1S = 40,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_2S = 41;
   */
  SOUND_ELEVENLABS_2S = 41,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_3S = 42;
   */
  SOUND_ELEVENLABS_3S = 42,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_5S = 43;
   */
  SOUND_ELEVENLABS_5S = 43,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_10S = 44;
   */
  SOUND_ELEVENLABS_10S = 44,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_15S = 45;
   */
  SOUND_ELEVENLABS_15S = 45,

  /**
   * @generated from enum value: PRICING_ACTION_SOUND_ELEVENLABS_30S = 46;
   */
  SOUND_ELEVENLABS_30S = 46,

  /**
   * Downloads.
   *
   * @generated from enum value: PRICING_ACTION_UPSCALE = 47;
   */
  UPSCALE = 47,

  /**
   * @generated from enum value: PRICING_ACTION_VECTORIZE = 48;
   */
  VECTORIZE = 48,

  /**
   * @generated from enum value: PRICING_ACTION_REMOVE_BACKGROUND = 49;
   */
  REMOVE_BACKGROUND = 49,

  /**
   * Moments.
   *
   * @generated from enum value: PRICING_ACTION_MOMENTS_GENERATION = 50;
   */
  MOMENTS_GENERATION = 50,

  /**
   * @generated from enum value: PRICING_ACTION_MOMENTS_UPLOADS = 51;
   */
  MOMENTS_UPLOADS = 51,

  /**
   * Tips.
   *
   * @generated from enum value: PRICING_ACTION_TIP_POST_AUTHOR = 52;
   */
  TIP_POST_AUTHOR = 52,

  /**
   * @generated from enum value: PRICING_ACTION_TIP_USER = 53;
   */
  TIP_USER = 53,

  /**
   * Image editor (non-preview aliases). Share pricing with the matching
   * _PREVIEW entries until the non-preview registry keys exist; FE clients
   * can address either name.
   *
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_PRO = 54;
   */
  IMAGE_EDITOR_GEMINI_3_PRO = 54,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE = 55;
   */
  IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE = 55,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_LITE = 57;
   */
  IMAGE_EDITOR_SEEDREAM_5_LITE = 57,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_RECRAFT_V4 = 58;
   */
  IMAGE_EDITOR_RECRAFT_V4 = 58,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_PRO = 59;
   */
  IMAGE_EDITOR_SEEDREAM_5_PRO = 59,

  /**
   * @generated from enum value: PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_GPT_IMAGE_2 = 60;
   */
  YOUTUBE_THUMBNAIL_GENERATOR_GPT_IMAGE_2 = 60,

  /**
   * Modalities
   *
   * @generated from enum value: PRICING_ACTION_GENERATE_PROMPT_FROM_TEXT = 61;
   */
  GENERATE_PROMPT_FROM_TEXT = 61,

  /**
   * @generated from enum value: PRICING_ACTION_GENERATE_PROMPT_FROM_IMAGE = 62;
   */
  GENERATE_PROMPT_FROM_IMAGE = 62,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_IDEOGRAM_V4_5 = 63;
   */
  IMAGE_EDITOR_IDEOGRAM_V4_5 = 63,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2 = 64;
   */
  IMAGE_EDITOR_OPENAI_GPT_IMAGE_2 = 64,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_FLASH = 65;
   */
  IMAGE_EDITOR_SEEDREAM_5_FLASH = 65,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_FLARE = 66;
   */
  IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_FLARE = 66,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_SUNBURST = 67;
   */
  IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_SUNBURST = 67,

  /**
   * @generated from enum value: PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_NANO_BANANA_2_1 = 68;
   */
  YOUTUBE_THUMBNAIL_GENERATOR_NANO_BANANA_2_1 = 68,

  /**
   * @generated from enum value: PRICING_ACTION_IMAGE_EDITOR_KREA_3 = 69;
   */
  IMAGE_EDITOR_KREA_3 = 69,

  /**
   * YouTube thumbnail made from a source video, tiered by the billed duration
   * (the selected range of the video): up to 120s, 600s and 1200s. Not tied to
   * a model: switching the video model changes the amounts, not these values.
   *
   * @generated from enum value: PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_120S = 70;
   */
  YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_120S = 70,

  /**
   * @generated from enum value: PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_600S = 71;
   */
  YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_600S = 71,

  /**
   * @generated from enum value: PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_1200S = 72;
   */
  YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_1200S = 72,
}

/**
 * @generated from enum creativefabrica.coins.v2.PricingAction
 */
export type PricingActionJson = "PRICING_ACTION_UNSPECIFIED" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_SAI" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA_PRO" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_NANO_BANANA_2" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_IMAGE_GEN_4" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_GROK_2" | "PRICING_ACTION_FLOW_GENERATE_IMAGE_GPT_IMAGE_2" | "PRICING_ACTION_LUMO_GENERATE_IMAGE_NANO_BANANA_2" | "PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_PRO_PREVIEW" | "PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE_PREVIEW" | "PRICING_ACTION_IMAGE_EDITOR_GEMINI_2_5" | "PRICING_ACTION_LOGO_GENERATOR" | "PRICING_ACTION_DESIGN_REVIEW" | "PRICING_ACTION_QUOTE_GENERATOR" | "PRICING_ACTION_COLLAGE" | "PRICING_ACTION_DOODLE_PET" | "PRICING_ACTION_REMOVE_PEOPLE_FROM_BACKGROUND" | "PRICING_ACTION_COLORING_PAGE_MAKER" | "PRICING_ACTION_WEDDING_INVITE" | "PRICING_ACTION_TOON_FAMILY" | "PRICING_ACTION_CAMERA_ANGLE" | "PRICING_ACTION_MARKETPLACE_EDITOR" | "PRICING_ACTION_SVG_GENERATOR" | "PRICING_ACTION_WATERMARK_REMOVER" | "PRICING_ACTION_ETSY_COACH" | "PRICING_ACTION_THREE_D_MODEL" | "PRICING_ACTION_MESH" | "PRICING_ACTION_FREEFORM_CAD" | "PRICING_ACTION_SPLAT" | "PRICING_ACTION_FONT_GENERATOR" | "PRICING_ACTION_MUSIC_ELEVENLABS_10S" | "PRICING_ACTION_MUSIC_ELEVENLABS_30S" | "PRICING_ACTION_MUSIC_ELEVENLABS_60S" | "PRICING_ACTION_MUSIC_ELEVENLABS_120S" | "PRICING_ACTION_MUSIC_ELEVENLABS_180S" | "PRICING_ACTION_MUSIC_LYRIA_3_FULL" | "PRICING_ACTION_MUSIC_LYRIA_3_30S" | "PRICING_ACTION_MUSIC_LYRIA_2_30S" | "PRICING_ACTION_MUSIC_LYRICS_ELEVENLABS" | "PRICING_ACTION_MUSIC_LYRICS_STRUCTURED" | "PRICING_ACTION_SOUND_ELEVENLABS_1S" | "PRICING_ACTION_SOUND_ELEVENLABS_2S" | "PRICING_ACTION_SOUND_ELEVENLABS_3S" | "PRICING_ACTION_SOUND_ELEVENLABS_5S" | "PRICING_ACTION_SOUND_ELEVENLABS_10S" | "PRICING_ACTION_SOUND_ELEVENLABS_15S" | "PRICING_ACTION_SOUND_ELEVENLABS_30S" | "PRICING_ACTION_UPSCALE" | "PRICING_ACTION_VECTORIZE" | "PRICING_ACTION_REMOVE_BACKGROUND" | "PRICING_ACTION_MOMENTS_GENERATION" | "PRICING_ACTION_MOMENTS_UPLOADS" | "PRICING_ACTION_TIP_POST_AUTHOR" | "PRICING_ACTION_TIP_USER" | "PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_PRO" | "PRICING_ACTION_IMAGE_EDITOR_GEMINI_3_1_FLASH_IMAGE" | "PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_LITE" | "PRICING_ACTION_IMAGE_EDITOR_RECRAFT_V4" | "PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_PRO" | "PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_GPT_IMAGE_2" | "PRICING_ACTION_GENERATE_PROMPT_FROM_TEXT" | "PRICING_ACTION_GENERATE_PROMPT_FROM_IMAGE" | "PRICING_ACTION_IMAGE_EDITOR_IDEOGRAM_V4_5" | "PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2" | "PRICING_ACTION_IMAGE_EDITOR_SEEDREAM_5_FLASH" | "PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_FLARE" | "PRICING_ACTION_IMAGE_EDITOR_OPENAI_GPT_IMAGE_2_5_SUNBURST" | "PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_NANO_BANANA_2_1" | "PRICING_ACTION_IMAGE_EDITOR_KREA_3" | "PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_120S" | "PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_600S" | "PRICING_ACTION_YOUTUBE_THUMBNAIL_GENERATOR_FROM_VIDEO_1200S";

/**
 * Describes the enum creativefabrica.coins.v2.PricingAction.
 */
export const PricingActionSchema: GenEnum<PricingAction, PricingActionJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 0);

/**
 * @generated from enum creativefabrica.coins.v2.AutoTopUpPack
 */
export enum AutoTopUpPack {
  /**
   * @generated from enum value: AUTO_TOP_UP_PACK_UNSPECIFIED = 0;
   */
  AUTO_TOP_UP_PACK_UNSPECIFIED = 0,

  /**
   * @generated from enum value: AUTO_TOP_UP_PACK_25K = 1;
   */
  AUTO_TOP_UP_PACK_25K = 1,

  /**
   * @generated from enum value: AUTO_TOP_UP_PACK_100K = 2;
   */
  AUTO_TOP_UP_PACK_100K = 2,

  /**
   * @generated from enum value: AUTO_TOP_UP_PACK_250K = 3;
   */
  AUTO_TOP_UP_PACK_250K = 3,

  /**
   * @generated from enum value: AUTO_TOP_UP_PACK_1M = 4;
   */
  AUTO_TOP_UP_PACK_1M = 4,
}

/**
 * @generated from enum creativefabrica.coins.v2.AutoTopUpPack
 */
export type AutoTopUpPackJson = "AUTO_TOP_UP_PACK_UNSPECIFIED" | "AUTO_TOP_UP_PACK_25K" | "AUTO_TOP_UP_PACK_100K" | "AUTO_TOP_UP_PACK_250K" | "AUTO_TOP_UP_PACK_1M";

/**
 * Describes the enum creativefabrica.coins.v2.AutoTopUpPack.
 */
export const AutoTopUpPackSchema: GenEnum<AutoTopUpPack, AutoTopUpPackJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 1);

/**
 * One-time Stripe coin pack bought when automatic team-pool top-up runs.
 * Lookup keys: coin_pack_team_1M / 5M / 10M / 30M.
 *
 * @generated from enum creativefabrica.coins.v2.TeamAutoTopUpPack
 */
export enum TeamAutoTopUpPack {
  /**
   * @generated from enum value: TEAM_AUTO_TOP_UP_PACK_UNSPECIFIED = 0;
   */
  TEAM_AUTO_TOP_UP_PACK_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_AUTO_TOP_UP_PACK_1M = 1;
   */
  TEAM_AUTO_TOP_UP_PACK_1M = 1,

  /**
   * @generated from enum value: TEAM_AUTO_TOP_UP_PACK_5M = 2;
   */
  TEAM_AUTO_TOP_UP_PACK_5M = 2,

  /**
   * @generated from enum value: TEAM_AUTO_TOP_UP_PACK_10M = 3;
   */
  TEAM_AUTO_TOP_UP_PACK_10M = 3,

  /**
   * @generated from enum value: TEAM_AUTO_TOP_UP_PACK_30M = 4;
   */
  TEAM_AUTO_TOP_UP_PACK_30M = 4,
}

/**
 * One-time Stripe coin pack bought when automatic team-pool top-up runs.
 * Lookup keys: coin_pack_team_1M / 5M / 10M / 30M.
 *
 * @generated from enum creativefabrica.coins.v2.TeamAutoTopUpPack
 */
export type TeamAutoTopUpPackJson = "TEAM_AUTO_TOP_UP_PACK_UNSPECIFIED" | "TEAM_AUTO_TOP_UP_PACK_1M" | "TEAM_AUTO_TOP_UP_PACK_5M" | "TEAM_AUTO_TOP_UP_PACK_10M" | "TEAM_AUTO_TOP_UP_PACK_30M";

/**
 * Describes the enum creativefabrica.coins.v2.TeamAutoTopUpPack.
 */
export const TeamAutoTopUpPackSchema: GenEnum<TeamAutoTopUpPack, TeamAutoTopUpPackJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 2);

/**
 * @generated from enum creativefabrica.coins.v2.StatisticsPeriod
 */
export enum StatisticsPeriod {
  /**
   * @generated from enum value: STATISTICS_PERIOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STATISTICS_PERIOD_THIS_MONTH = 1;
   */
  THIS_MONTH = 1,

  /**
   * @generated from enum value: STATISTICS_PERIOD_LAST_MONTH = 2;
   */
  LAST_MONTH = 2,

  /**
   * @generated from enum value: STATISTICS_PERIOD_LAST_3_MONTHS = 3;
   */
  LAST_3_MONTHS = 3,

  /**
   * @generated from enum value: STATISTICS_PERIOD_LAST_12_MONTHS = 4;
   */
  LAST_12_MONTHS = 4,
}

/**
 * @generated from enum creativefabrica.coins.v2.StatisticsPeriod
 */
export type StatisticsPeriodJson = "STATISTICS_PERIOD_UNSPECIFIED" | "STATISTICS_PERIOD_THIS_MONTH" | "STATISTICS_PERIOD_LAST_MONTH" | "STATISTICS_PERIOD_LAST_3_MONTHS" | "STATISTICS_PERIOD_LAST_12_MONTHS";

/**
 * Describes the enum creativefabrica.coins.v2.StatisticsPeriod.
 */
export const StatisticsPeriodSchema: GenEnum<StatisticsPeriod, StatisticsPeriodJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 3);

/**
 * @generated from enum creativefabrica.coins.v2.TransactionType
 */
export enum TransactionType {
  /**
   * @generated from enum value: TRANSACTION_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_TYPE_SPEND = 1;
   */
  SPEND = 1,

  /**
   * @generated from enum value: TRANSACTION_TYPE_EARN = 2;
   */
  EARN = 2,

  /**
   * @generated from enum value: TRANSACTION_TYPE_TOP_UP = 3;
   */
  TOP_UP = 3,
}

/**
 * @generated from enum creativefabrica.coins.v2.TransactionType
 */
export type TransactionTypeJson = "TRANSACTION_TYPE_UNSPECIFIED" | "TRANSACTION_TYPE_SPEND" | "TRANSACTION_TYPE_EARN" | "TRANSACTION_TYPE_TOP_UP";

/**
 * Describes the enum creativefabrica.coins.v2.TransactionType.
 */
export const TransactionTypeSchema: GenEnum<TransactionType, TransactionTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 4);

/**
 * @generated from enum creativefabrica.coins.v2.TransactionStatus
 */
export enum TransactionStatus {
  /**
   * @generated from enum value: TRANSACTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: TRANSACTION_STATUS_CONFIRMED = 2;
   */
  CONFIRMED = 2,

  /**
   * @generated from enum value: TRANSACTION_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,
}

/**
 * @generated from enum creativefabrica.coins.v2.TransactionStatus
 */
export type TransactionStatusJson = "TRANSACTION_STATUS_UNSPECIFIED" | "TRANSACTION_STATUS_PENDING" | "TRANSACTION_STATUS_CONFIRMED" | "TRANSACTION_STATUS_CANCELLED";

/**
 * Describes the enum creativefabrica.coins.v2.TransactionStatus.
 */
export const TransactionStatusSchema: GenEnum<TransactionStatus, TransactionStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 5);

/**
 * @generated from enum creativefabrica.coins.v2.TransactionOrigin
 */
export enum TransactionOrigin {
  /**
   * @generated from enum value: TRANSACTION_ORIGIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_PRODUCT_DOWNLOADED = 1;
   */
  PRODUCT_DOWNLOADED = 1,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_PRODUCT_REVIEWED = 2;
   */
  PRODUCT_REVIEWED = 2,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_PRODUCT_PROJECT_POSTED = 3;
   */
  PRODUCT_PROJECT_POSTED = 3,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_SOCIAL_POST_TIPPED = 4;
   */
  SOCIAL_POST_TIPPED = 4,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_CF_ADMIN = 5;
   */
  CF_ADMIN = 5,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TIP = 6;
   */
  TIP = 6,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_USER_REGISTERED = 7;
   */
  USER_REGISTERED = 7,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FONT_GENERATED = 8;
   */
  FONT_GENERATED = 8,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_ITERATION_GENERATED = 9;
   */
  FLOW_ITERATION_GENERATED = 9,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_LOGO_GENERATED = 10;
   */
  LOGO_GENERATED = 10,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_TRIAL = 11;
   */
  AI_STUDIO_SUBSCRIPTION_TRIAL = 11,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_PAID = 12;
   */
  AI_STUDIO_SUBSCRIPTION_PAID = 12,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_COINS_WALLET_TOP_UP = 13;
   */
  COINS_WALLET_TOP_UP = 13,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_DESIGN_REVIEWED = 14;
   */
  DESIGN_REVIEWED = 14,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_VECTORIZED_IMAGE_DOWNLOAD = 15;
   */
  VECTORIZED_IMAGE_DOWNLOAD = 15,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_UPSCALED_IMAGE_DOWNLOAD = 16;
   */
  UPSCALED_IMAGE_DOWNLOAD = 16,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_BACKGROUND_REMOVED_IMAGE_DOWNLOAD = 17;
   */
  BACKGROUND_REMOVED_IMAGE_DOWNLOAD = 17,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_TRIAL_CANCELLED = 18;
   */
  AI_STUDIO_SUBSCRIPTION_TRIAL_CANCELLED = 18,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_QUOTE_GENERATED = 19;
   */
  AI_QUOTE_GENERATED = 19,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED = 20;
   */
  IMAGE_EDITED = 20,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA_PRO = 21;
   */
  FLOW_GENERATED_NANO_BANANA_PRO = 21,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA = 22;
   */
  FLOW_GENERATED_NANO_BANANA = 22,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_IMAGEGEN_4 = 23;
   */
  FLOW_GENERATED_IMAGEGEN_4 = 23,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_10_SECONDS = 24;
   */
  AI_MUSIC_GENERATED_ELEVEN_LABS_10_SECONDS = 24,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_30_SECONDS = 25;
   */
  AI_MUSIC_GENERATED_ELEVEN_LABS_30_SECONDS = 25,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_60_SECONDS = 26;
   */
  AI_MUSIC_GENERATED_ELEVEN_LABS_60_SECONDS = 26,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_120_SECONDS = 27;
   */
  AI_MUSIC_GENERATED_ELEVEN_LABS_120_SECONDS = 27,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_180_SECONDS = 28;
   */
  AI_MUSIC_GENERATED_ELEVEN_LABS_180_SECONDS = 28,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_WATERMARK_REMOVED = 29;
   */
  AI_WATERMARK_REMOVED = 29,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_1_SECONDS = 30;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_1_SECONDS = 30,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_5_SECONDS = 31;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_5_SECONDS = 31,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_10_SECONDS = 32;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_10_SECONDS = 32,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_15_SECONDS = 33;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_15_SECONDS = 33,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_30_SECONDS = 34;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_30_SECONDS = 34,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_ACTIVATION_BONUS = 35;
   */
  AI_STUDIO_SUBSCRIPTION_ACTIVATION_BONUS = 35,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_2_SECONDS = 36;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_2_SECONDS = 36,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_3_SECONDS = 37;
   */
  AI_SOUND_GENERATED_ELEVEN_LABS_3_SECONDS = 37,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SPEECH_GENERATED = 38;
   */
  AI_SPEECH_GENERATED = 38,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_COLLAGE_GENERATED = 39;
   */
  AI_COLLAGE_GENERATED = 39,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_PRO_PREVIEW = 40;
   */
  IMAGE_EDITED_GEMINI_3_PRO_PREVIEW = 40,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_THREE_D_MODEL_GENERATED = 41;
   */
  THREE_D_MODEL_GENERATED = 41,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_DOODLE_PET_GENERATED = 42;
   */
  AI_DOODLE_PET_GENERATED = 42,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_PEOPLE_REMOVER_FROM_BACKGROUND = 43;
   */
  AI_PEOPLE_REMOVER_FROM_BACKGROUND = 43,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_COLORING_PAGE_GENERATED = 44;
   */
  AI_COLORING_PAGE_GENERATED = 44,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED = 45;
   */
  AI_VIDEO_GENERATED = 45,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_WEDDING_INVITE_GENERATED = 46;
   */
  AI_WEDDING_INVITE_GENERATED = 46,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_REFERRAL = 47;
   */
  REFERRAL = 47,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_ETSY_COACH_AUDIT = 48;
   */
  AI_ETSY_COACH_AUDIT = 48,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_PHOTO_STYLE = 49;
   */
  AI_PHOTO_STYLE = 49,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_GROK_2_IMAGE_GEN_1212 = 50;
   */
  FLOW_GENERATED_GROK_2_IMAGE_GEN_1212 = 50,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TOON_FAMILY_GENERATED = 51;
   */
  TOON_FAMILY_GENERATED = 51,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_MESH_GENERATOR = 52;
   */
  MESH_GENERATOR = 52,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_REWARDS = 53;
   */
  REWARDS = 53,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GROK = 54;
   */
  AI_VIDEO_GENERATED_GROK = 54,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_3 = 55;
   */
  AI_MUSIC_GENERATED_LYRIA_3 = 55,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_RENEWED = 56;
   */
  AI_STUDIO_SUBSCRIPTION_RENEWED = 56,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_COIN_PACK_SUBSCRIPTION_STARTED = 57;
   */
  COIN_PACK_SUBSCRIPTION_STARTED = 57,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_COIN_PACK_SUBSCRIPTION_RENEWED = 58;
   */
  COIN_PACK_SUBSCRIPTION_RENEWED = 58,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDDANCE_2 = 59;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDDANCE_2 = 59,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_2 = 60;
   */
  AI_MUSIC_GENERATED_LYRIA_2 = 60,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_1_5_PRO = 61;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_1_5_PRO = 61,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA_2 = 62;
   */
  FLOW_GENERATED_NANO_BANANA_2 = 62,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE_PREVIEW = 63;
   */
  IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE_PREVIEW = 63,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_QUOTE_GENERATED_NANO_BANANA_2 = 64;
   */
  AI_QUOTE_GENERATED_NANO_BANANA_2 = 64,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_3_PREVIEW = 65;
   */
  AI_MUSIC_GENERATED_LYRIA_3_PREVIEW = 65,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_GENERATED_LYRICS = 66;
   */
  AI_GENERATED_LYRICS = 66,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_VIDEO_UPSCALER_TOPAZLABS = 67;
   */
  VIDEO_UPSCALER_TOPAZLABS = 67,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MOCKUP_GENERATOR = 68;
   */
  AI_MOCKUP_GENERATOR = 68,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3 = 69;
   */
  AI_VIDEO_GENERATED_KLING_AI_V3 = 69,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_CAMERA_ANGLE = 70;
   */
  AI_CAMERA_ANGLE = 70,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MARKETPLACE_EDITOR = 71;
   */
  AI_MARKETPLACE_EDITOR = 71,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SVG_GENERATOR = 72;
   */
  AI_SVG_GENERATOR = 72,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FREEFORM_CAD = 73;
   */
  FREEFORM_CAD = 73,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_SPLAT_GENERATOR = 74;
   */
  SPLAT_GENERATOR = 74,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_RUNWAY_GEN_4_5 = 75;
   */
  AI_VIDEO_GENERATED_RUNWAY_GEN_4_5 = 75,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_LUMA_RAY_2 = 76;
   */
  AI_VIDEO_GENERATED_LUMA_RAY_2 = 76,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIKA_2_1 = 77;
   */
  AI_VIDEO_GENERATED_FAL_PIKA_2_1 = 77,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_MUSIC_LYRICS_STRUCTURED = 78;
   */
  AI_MUSIC_LYRICS_STRUCTURED = 78,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3_MOTION_CONTROL = 79;
   */
  AI_VIDEO_GENERATED_KLING_AI_V3_MOTION_CONTROL = 79,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_INVOICE_REFUNDED = 80;
   */
  INVOICE_REFUNDED = 80,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_MOMENTS = 81;
   */
  MOMENTS = 81,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_MOMENTS_GENERATION = 82;
   */
  MOMENTS_GENERATION = 82,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_VIDEO_CUTOUTS_BGR = 83;
   */
  VIDEO_CUTOUTS_BGR = 83,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1 = 84;
   */
  AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1 = 84,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_SVG_GENERATOR_QUIVERAI_ARROW_1_1 = 85;
   */
  AI_SVG_GENERATOR_QUIVERAI_ARROW_1_1 = 85,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_HAPPY_HORSE_V1 = 86;
   */
  AI_VIDEO_EDITED_ALIBABA_HAPPY_HORSE_V1 = 86,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_2_7 = 87;
   */
  AI_VIDEO_GENERATED_ALIBABA_WAN_2_7 = 87,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_WAN_2_7_SPICY = 88;
   */
  AI_VIDEO_GENERATED_MULEROUTER_WAN_2_7_SPICY = 88,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_LTX_2_3 = 89;
   */
  AI_VIDEO_GENERATED_FAL_LTX_2_3 = 89,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE = 90;
   */
  IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE = 90,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3_TURBO = 91;
   */
  AI_VIDEO_GENERATED_KLING_AI_V3_TURBO = 91,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_LUMA_RAY_3_2 = 92;
   */
  AI_VIDEO_GENERATED_LUMA_RAY_3_2 = 92,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIXVERSE_V6 = 93;
   */
  AI_VIDEO_GENERATED_FAL_PIXVERSE_V6 = 93,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIXVERSE_C1 = 94;
   */
  AI_VIDEO_GENERATED_FAL_PIXVERSE_C1 = 94,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_HEYGEN_AVATAR_5 = 95;
   */
  AI_VIDEO_GENERATED_HEYGEN_AVATAR_5 = 95,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1_1 = 96;
   */
  AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1_1 = 96,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_OPENAI_GPT_IMAGE_2 = 97;
   */
  FLOW_GENERATED_OPENAI_GPT_IMAGE_2 = 97,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_SEEDREAM_5_LITE = 98;
   */
  FLOW_GENERATED_SEEDREAM_5_LITE = 98,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V3_IMAGE = 99;
   */
  FLOW_GENERATED_KLING_V3_IMAGE = 99,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_IMAGE_O1 = 100;
   */
  FLOW_GENERATED_KLING_IMAGE_O1 = 100,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V3_OMNI_IMAGE = 101;
   */
  FLOW_GENERATED_KLING_V3_OMNI_IMAGE = 101,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V2_1_IMAGE = 102;
   */
  FLOW_GENERATED_KLING_V2_1_IMAGE = 102,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_Z_IMAGE_SPICY = 103;
   */
  FLOW_GENERATED_Z_IMAGE_SPICY = 103,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_QWEN_IMAGE_EDIT_SPICY = 104;
   */
  FLOW_GENERATED_QWEN_IMAGE_EDIT_SPICY = 104,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_LITE = 105;
   */
  IMAGE_EDITED_SEEDREAM_5_LITE = 105,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH = 106;
   */
  AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH = 106,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_GEMINI_OMNI_FLASH = 107;
   */
  AI_VIDEO_EDITED_GEMINI_OMNI_FLASH = 107,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_FAST = 108;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_FAST = 108,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_MINI = 109;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_MINI = 109,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V3_OMNI = 110;
   */
  AI_VIDEO_GENERATED_KLING_V3_OMNI = 110,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_RECRAFT_V4 = 111;
   */
  IMAGE_EDITED_RECRAFT_V4 = 111,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_OPENAI_GPT_IMAGE_2 = 112;
   */
  AI_YOUTUBE_THUMBNAIL_GENERATED_OPENAI_GPT_IMAGE_2 = 112,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_PRO = 113;
   */
  IMAGE_EDITED_SEEDREAM_5_PRO = 113,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3 = 114;
   */
  AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3 = 114,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_FLOW_GENERATED_QUIVERAI_ARROW_1_1 = 115;
   */
  FLOW_GENERATED_QUIVERAI_ARROW_1_1 = 115,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FLUX_3 = 116;
   */
  AI_VIDEO_GENERATED_FLUX_3 = 116,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5 = 117;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5 = 117,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_PIKA_2_5 = 118;
   */
  AI_VIDEO_GENERATED_PIKA_2_5 = 118,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_3_0 = 119;
   */
  AI_VIDEO_GENERATED_ALIBABA_WAN_3_0 = 119,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_3_0_PRIME = 120;
   */
  AI_VIDEO_GENERATED_ALIBABA_WAN_3_0_PRIME = 120,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0 = 121;
   */
  AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0 = 121,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO = 122;
   */
  AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO = 122,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GROK_IMAGINE_VIDEO_1_5 = 123;
   */
  AI_VIDEO_GENERATED_GROK_IMAGINE_VIDEO_1_5 = 123,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_GROK_IMAGINE_VIDEO_1_5 = 124;
   */
  AI_VIDEO_EDITED_GROK_IMAGINE_VIDEO_1_5 = 124,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_MINIMAX_HAILUO_V3 = 125;
   */
  AI_VIDEO_EDITED_MINIMAX_HAILUO_V3 = 125,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1 = 126;
   */
  AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1 = 126,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED = 127;
   */
  AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED = 127,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX = 128;
   */
  AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX = 128,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_WAN_3_0 = 129;
   */
  AI_VIDEO_EDITED_ALIBABA_WAN_3_0 = 129,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_WAN_3_0_PRIME = 130;
   */
  AI_VIDEO_EDITED_ALIBABA_WAN_3_0_PRIME = 130,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_V1 = 131;
   */
  VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_V1 = 131,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_PRO_V1 = 132;
   */
  VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_PRO_V1 = 132,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_FAST = 133;
   */
  AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_FAST = 133,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_HIGH = 134;
   */
  AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_HIGH = 134,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TEAM_COINS_WALLET_TOP_UP = 135;
   */
  TEAM_COINS_WALLET_TOP_UP = 135,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_FAST = 136;
   */
  AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_FAST = 136,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX_TURBO = 137;
   */
  AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX_TURBO = 137,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TEAM_SUBSCRIPTION_PAID = 138;
   */
  TEAM_SUBSCRIPTION_PAID = 138,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TEAM_SUBSCRIPTION_RENEWED = 139;
   */
  TEAM_SUBSCRIPTION_RENEWED = 139,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_TEAM_SEAT_ADDED = 140;
   */
  TEAM_SEAT_ADDED = 140,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_TURBO = 142;
   */
  AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_TURBO = 142,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO_TURBO = 143;
   */
  AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO_TURBO = 143,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_EDITED_BYTEDANCE_SEEDANCE_2_5 = 144;
   */
  AI_VIDEO_EDITED_BYTEDANCE_SEEDANCE_2_5 = 144,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED = 145;
   */
  AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED = 145,

  /**
   * Vectorizer download billed on the marketplace surface: requires All Access
   * rather than the Studio AI subscription the studio-surface origin requires.
   * Must keep the same number as the v1 enum; coins casts between them.
   *
   * @generated from enum value: TRANSACTION_ORIGIN_MARKETPLACE_VECTORIZED_IMAGE_DOWNLOAD = 146;
   */
  MARKETPLACE_VECTORIZED_IMAGE_DOWNLOAD = 146,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_IDEOGRAM_V4_5 = 147;
   */
  IMAGE_EDITED_IDEOGRAM_V4_5 = 147,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2 = 148;
   */
  IMAGE_EDITED_OPENAI_GPT_IMAGE_2 = 148,

  /**
   * Must keep the same number as the v1 enum; coins casts between them
   * (149/150 are v1-only All Access origins).
   *
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_FLASH = 151;
   */
  IMAGE_EDITED_SEEDREAM_5_FLASH = 151,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_FLARE = 152;
   */
  IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_FLARE = 152,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_SUNBURST = 153;
   */
  IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_SUNBURST = 153,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_GOOGLE_NANO_BANANA_2_1 = 154;
   */
  AI_YOUTUBE_THUMBNAIL_GENERATED_GOOGLE_NANO_BANANA_2_1 = 154,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V4_FLASH = 155;
   */
  AI_VIDEO_GENERATED_KLING_V4_FLASH = 155,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V4 = 156;
   */
  AI_VIDEO_GENERATED_KLING_V4 = 156,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_IMAGE_EDITED_KREA_3 = 157;
   */
  IMAGE_EDITED_KREA_3 = 157,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_HEYGEN_VIDEO_1 = 158;
   */
  AI_VIDEO_GENERATED_HEYGEN_VIDEO_1 = 158,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_120S = 159;
   */
  AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_120S = 159,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_600S = 160;
   */
  AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_600S = 160,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_1200S = 161;
   */
  AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_1200S = 161,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FLUX_3_MAX = 162;
   */
  AI_VIDEO_GENERATED_FLUX_3_MAX = 162,

  /**
   * @generated from enum value: TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_VIVIX_W1 = 163;
   */
  AI_VIDEO_GENERATED_VIVIX_W1 = 163,
}

/**
 * @generated from enum creativefabrica.coins.v2.TransactionOrigin
 */
export type TransactionOriginJson = "TRANSACTION_ORIGIN_UNSPECIFIED" | "TRANSACTION_ORIGIN_PRODUCT_DOWNLOADED" | "TRANSACTION_ORIGIN_PRODUCT_REVIEWED" | "TRANSACTION_ORIGIN_PRODUCT_PROJECT_POSTED" | "TRANSACTION_ORIGIN_SOCIAL_POST_TIPPED" | "TRANSACTION_ORIGIN_CF_ADMIN" | "TRANSACTION_ORIGIN_TIP" | "TRANSACTION_ORIGIN_USER_REGISTERED" | "TRANSACTION_ORIGIN_FONT_GENERATED" | "TRANSACTION_ORIGIN_FLOW_ITERATION_GENERATED" | "TRANSACTION_ORIGIN_LOGO_GENERATED" | "TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_TRIAL" | "TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_PAID" | "TRANSACTION_ORIGIN_COINS_WALLET_TOP_UP" | "TRANSACTION_ORIGIN_DESIGN_REVIEWED" | "TRANSACTION_ORIGIN_VECTORIZED_IMAGE_DOWNLOAD" | "TRANSACTION_ORIGIN_UPSCALED_IMAGE_DOWNLOAD" | "TRANSACTION_ORIGIN_BACKGROUND_REMOVED_IMAGE_DOWNLOAD" | "TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_TRIAL_CANCELLED" | "TRANSACTION_ORIGIN_AI_QUOTE_GENERATED" | "TRANSACTION_ORIGIN_IMAGE_EDITED" | "TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA_PRO" | "TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA" | "TRANSACTION_ORIGIN_FLOW_GENERATED_IMAGEGEN_4" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_10_SECONDS" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_30_SECONDS" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_60_SECONDS" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_120_SECONDS" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_ELEVEN_LABS_180_SECONDS" | "TRANSACTION_ORIGIN_AI_WATERMARK_REMOVED" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_1_SECONDS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_5_SECONDS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_10_SECONDS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_15_SECONDS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_30_SECONDS" | "TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_ACTIVATION_BONUS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_2_SECONDS" | "TRANSACTION_ORIGIN_AI_SOUND_GENERATED_ELEVEN_LABS_3_SECONDS" | "TRANSACTION_ORIGIN_AI_SPEECH_GENERATED" | "TRANSACTION_ORIGIN_AI_COLLAGE_GENERATED" | "TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_PRO_PREVIEW" | "TRANSACTION_ORIGIN_THREE_D_MODEL_GENERATED" | "TRANSACTION_ORIGIN_AI_DOODLE_PET_GENERATED" | "TRANSACTION_ORIGIN_AI_PEOPLE_REMOVER_FROM_BACKGROUND" | "TRANSACTION_ORIGIN_AI_COLORING_PAGE_GENERATED" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED" | "TRANSACTION_ORIGIN_AI_WEDDING_INVITE_GENERATED" | "TRANSACTION_ORIGIN_REFERRAL" | "TRANSACTION_ORIGIN_AI_ETSY_COACH_AUDIT" | "TRANSACTION_ORIGIN_AI_PHOTO_STYLE" | "TRANSACTION_ORIGIN_FLOW_GENERATED_GROK_2_IMAGE_GEN_1212" | "TRANSACTION_ORIGIN_TOON_FAMILY_GENERATED" | "TRANSACTION_ORIGIN_MESH_GENERATOR" | "TRANSACTION_ORIGIN_REWARDS" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GROK" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_3" | "TRANSACTION_ORIGIN_AI_STUDIO_SUBSCRIPTION_RENEWED" | "TRANSACTION_ORIGIN_COIN_PACK_SUBSCRIPTION_STARTED" | "TRANSACTION_ORIGIN_COIN_PACK_SUBSCRIPTION_RENEWED" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDDANCE_2" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_2" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_1_5_PRO" | "TRANSACTION_ORIGIN_FLOW_GENERATED_NANO_BANANA_2" | "TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE_PREVIEW" | "TRANSACTION_ORIGIN_AI_QUOTE_GENERATED_NANO_BANANA_2" | "TRANSACTION_ORIGIN_AI_MUSIC_GENERATED_LYRIA_3_PREVIEW" | "TRANSACTION_ORIGIN_AI_GENERATED_LYRICS" | "TRANSACTION_ORIGIN_VIDEO_UPSCALER_TOPAZLABS" | "TRANSACTION_ORIGIN_AI_MOCKUP_GENERATOR" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3" | "TRANSACTION_ORIGIN_AI_CAMERA_ANGLE" | "TRANSACTION_ORIGIN_AI_MARKETPLACE_EDITOR" | "TRANSACTION_ORIGIN_AI_SVG_GENERATOR" | "TRANSACTION_ORIGIN_FREEFORM_CAD" | "TRANSACTION_ORIGIN_SPLAT_GENERATOR" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_RUNWAY_GEN_4_5" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_LUMA_RAY_2" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIKA_2_1" | "TRANSACTION_ORIGIN_AI_MUSIC_LYRICS_STRUCTURED" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3_MOTION_CONTROL" | "TRANSACTION_ORIGIN_INVOICE_REFUNDED" | "TRANSACTION_ORIGIN_MOMENTS" | "TRANSACTION_ORIGIN_MOMENTS_GENERATION" | "TRANSACTION_ORIGIN_VIDEO_CUTOUTS_BGR" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1" | "TRANSACTION_ORIGIN_AI_SVG_GENERATOR_QUIVERAI_ARROW_1_1" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_HAPPY_HORSE_V1" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_2_7" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_WAN_2_7_SPICY" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_LTX_2_3" | "TRANSACTION_ORIGIN_IMAGE_EDITED_GEMINI_3_1_FLASH_IMAGE" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_AI_V3_TURBO" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_LUMA_RAY_3_2" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIXVERSE_V6" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FAL_PIXVERSE_C1" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_HEYGEN_AVATAR_5" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_HAPPY_HORSE_V1_1" | "TRANSACTION_ORIGIN_FLOW_GENERATED_OPENAI_GPT_IMAGE_2" | "TRANSACTION_ORIGIN_FLOW_GENERATED_SEEDREAM_5_LITE" | "TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V3_IMAGE" | "TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_IMAGE_O1" | "TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V3_OMNI_IMAGE" | "TRANSACTION_ORIGIN_FLOW_GENERATED_KLING_V2_1_IMAGE" | "TRANSACTION_ORIGIN_FLOW_GENERATED_Z_IMAGE_SPICY" | "TRANSACTION_ORIGIN_FLOW_GENERATED_QWEN_IMAGE_EDIT_SPICY" | "TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_LITE" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_GEMINI_OMNI_FLASH" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_FAST" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_MINI" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V3_OMNI" | "TRANSACTION_ORIGIN_IMAGE_EDITED_RECRAFT_V4" | "TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_OPENAI_GPT_IMAGE_2" | "TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_PRO" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3" | "TRANSACTION_ORIGIN_FLOW_GENERATED_QUIVERAI_ARROW_1_1" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FLUX_3" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_PIKA_2_5" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_3_0" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_ALIBABA_WAN_3_0_PRIME" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GROK_IMAGINE_VIDEO_1_5" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_GROK_IMAGINE_VIDEO_1_5" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_MINIMAX_HAILUO_V3" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_GEMINI_OMNI_FLASH_1_1_VIDEO_EXTENDED" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_WAN_3_0" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_ALIBABA_WAN_3_0_PRIME" | "TRANSACTION_ORIGIN_VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_V1" | "TRANSACTION_ORIGIN_VIDEO_UPSCALER_BYTEPLUS_VIDEO_ENHANCE_PRO_V1" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_FAST" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_FLUX_3_VIDEO_EDITING_HIGH" | "TRANSACTION_ORIGIN_TEAM_COINS_WALLET_TOP_UP" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_FAST" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MINIMAX_HAILUO_V3_MAX_TURBO" | "TRANSACTION_ORIGIN_TEAM_SUBSCRIPTION_PAID" | "TRANSACTION_ORIGIN_TEAM_SUBSCRIPTION_RENEWED" | "TRANSACTION_ORIGIN_TEAM_SEAT_ADDED" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_TURBO" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_MULEROUTER_BERRY_1_0_PRO_TURBO" | "TRANSACTION_ORIGIN_AI_VIDEO_EDITED_BYTEDANCE_SEEDANCE_2_5" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_BYTEDANCE_SEEDANCE_2_5_VIDEO_EXTENDED" | "TRANSACTION_ORIGIN_MARKETPLACE_VECTORIZED_IMAGE_DOWNLOAD" | "TRANSACTION_ORIGIN_IMAGE_EDITED_IDEOGRAM_V4_5" | "TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2" | "TRANSACTION_ORIGIN_IMAGE_EDITED_SEEDREAM_5_FLASH" | "TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_FLARE" | "TRANSACTION_ORIGIN_IMAGE_EDITED_OPENAI_GPT_IMAGE_2_5_SUNBURST" | "TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_GOOGLE_NANO_BANANA_2_1" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V4_FLASH" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_KLING_V4" | "TRANSACTION_ORIGIN_IMAGE_EDITED_KREA_3" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_HEYGEN_VIDEO_1" | "TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_120S" | "TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_600S" | "TRANSACTION_ORIGIN_AI_YOUTUBE_THUMBNAIL_GENERATED_FROM_VIDEO_1200S" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_FLUX_3_MAX" | "TRANSACTION_ORIGIN_AI_VIDEO_GENERATED_VIVIX_W1";

/**
 * Describes the enum creativefabrica.coins.v2.TransactionOrigin.
 */
export const TransactionOriginSchema: GenEnum<TransactionOrigin, TransactionOriginJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_coins_v2_types, 6);

